
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/category/[slug]",
      function () {
        return require("private-next-pages/blogs/category/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/category/[slug]"])
      });
    }
  